// # 把後台 Quill（1.x）存出來的 HTML 還原成一般瀏覽器能正確顯示的結構
//
// Quill 1.x 的巢狀清單是「平的」：每一層都放在同一層的 <ol>/<ul>，
// 用 class="ql-indent-N" 標示縮排；而且只要清單型別一換（編號 → 圓點），
// 就會切成另一個 <ol>/<ul>。例如：
//
//   <ol><li>購票須知</li></ol>
//   <ul><li class="ql-indent-1">子項目</li></ul>
//   <ol><li>活動異動</li></ol>
//
// 在 Quill 編輯器裡靠它自己的 CSS 顯示正常，但前台直接渲染時，
// 每個 <ol> 都會從 1 重新編號、子項目也不會縮排。
// 這裡把相鄰的清單依縮排重新組成真正的巢狀清單，編號就能接續。

const isList = (node) => node?.nodeName === "OL" || node?.nodeName === "UL";

const INDENT_CLASS = /(?:^|\s)ql-indent-(\d+)(?=\s|$)/;

const takeIndent = (li) => {
  const match = li.className.match(INDENT_CLASS);
  if (!match) return 0;
  li.classList.remove(`ql-indent-${match[1]}`);
  if (!li.className) li.removeAttribute("class");
  return Number(match[1]);
};

// # 一段連續的清單 → 巢狀清單
const nestListRun = (doc, lists) => {
  const fragment = doc.createDocumentFragment();
  const stack = []; // 目前開著的每一層：{ list, indent }

  lists.forEach((source) => {
    const tag = source.nodeName.toLowerCase();

    Array.from(source.children).forEach((li) => {
      const indent = takeIndent(li);

      // 回到這一層：比它深的層級都收起來
      while (stack.length && stack[stack.length - 1].indent > indent) {
        stack.pop();
      }
      // 同一層但換了清單型別，視為另一份清單
      const top = stack[stack.length - 1];
      if (top && top.indent === indent && top.list.nodeName !== source.nodeName) {
        stack.pop();
      }

      let current = stack[stack.length - 1];
      if (!current || current.indent < indent) {
        const list = doc.createElement(tag);
        // 掛在上一層最後一個項目底下；最外層就直接放進片段
        (current ? current.list.lastElementChild : fragment).appendChild(list);
        current = { list, indent };
        stack.push(current);
      }

      current.list.appendChild(li);
    });
  });

  return fragment;
};

export const normalizeQuillHtml = (html) => {
  if (!html || typeof DOMParser === "undefined") return html;

  const doc = new DOMParser().parseFromString(html, "text/html");
  const { body } = doc;

  let node = body.firstChild;
  while (node) {
    if (!isList(node)) {
      node = node.nextSibling;
      continue;
    }

    const run = [];
    while (isList(node)) {
      run.push(node);
      node = node.nextSibling;
    }

    const anchor = run[0];
    anchor.replaceWith(nestListRun(doc, run));
    run.slice(1).forEach((list) => list.remove());
  }

  return body.innerHTML;
};

export default normalizeQuillHtml;
